export const PARCEL_WEIGHT_DISCREPANCY_THRESHOLD = 0.4;

export interface DeclaredParcelWeight {
  poids?: number | string | null;
}

/** Ne retourne un total que lorsque tous les colis ont un poids valide. */
export function getCompleteParcelWeight(
  parcels: DeclaredParcelWeight[] | null | undefined,
  expectedCount = parcels?.length,
) {
  if (!Array.isArray(parcels) || parcels.length === 0 || parcels.length !== expectedCount) {
    return null;
  }

  let total = 0;
  for (const parcel of parcels) {
    const rawWeight = parcel?.poids;
    const weight =
      typeof rawWeight === "number" || typeof rawWeight === "string"
        ? Number(rawWeight)
        : NaN;
    if (!Number.isFinite(weight) || weight <= 0) {
      return null;
    }
    total += weight;
  }
  return Number.isFinite(total) ? total : null;
}

/** Signale uniquement un poids déclaré supérieur d'au moins 40 % à la référence. */
export function getParcelWeightDiscrepancy(
  referenceWeight: number | null | undefined,
  parcels: DeclaredParcelWeight[],
  expectedCount = parcels.length,
) {
  const reference = Number(referenceWeight);
  if (!Number.isFinite(reference) || reference <= 0) return null;
  const declared = getCompleteParcelWeight(parcels, expectedCount);
  if (declared === null) return { kind: "incomplete" as const };
  if (declared <= reference) return null;
  const difference = declared - reference;
  // Tolérance uniquement pour les erreurs d'arrondi flottant au seuil exact.
  const tolerance = Number.EPSILON * reference * 4;
  if (difference + tolerance < reference * PARCEL_WEIGHT_DISCREPANCY_THRESHOLD) {
    return null;
  }

  return {
    kind: "discrepancy" as const,
    reference,
    declared,
    percentage: (difference / reference) * 100,
  };
}
